import {isEmpty} from "lodash/lang";
import EventService from "@/services/EventService";

export default {
    data() {
        return {
            isLoading: true,
            isEditing: false,
            schema: {},
            form: {},
            errors: {},
        }
    },
    computed: {
        isCreate() {
            return isEmpty(this.instance);
        },
        hasErrors() {
            return !isEmpty(this.errors);
        },
    },
    created() {
        /** On creation, load the schema and add it to the data.
         * TODO: Add error handling
         */
        const promises = [this.loadSchema()];
        if (!this.isCreate && this.doLoadData) {
            promises.push(this.loadData());
        }
        Promise.all(promises).finally(() => {
            this.isLoading = false;
        });
    },
    props: {
        instance: {
            type: Object,
            required: false
        },
        formUrl: {
            type: String,
            required: true
        },
        doLoadData: { //
            type: Boolean,
            default: true,
        }
    },
    methods: {
        isEmpty,
        updateKeyPair(payload) {
            Object.assign(this.form, payload);
            this.isEditing = true;
            console.log("updateKeyPair:", payload, this.form);
            this.$emit('updated', this.form);
        },
        loadSchema() {
            return EventService.getFormSchema(this.formUrl)
                .then(data => {
                    if ('PUT' in data) {
                        // PUT for UPDATE action
                        this.schema = data['PUT'];
                    } else if ('POST' in data) {
                        // POST for CREATE action
                        this.schema = data['POST'];
                    }
                });
        },
        loadData() {
            return EventService.getFormData(this.formUrl)
                .then(data => {
                    this.form = data.data;
                });
        },
        handleError(error) {
            console.log(error);
            if (error.response) {
                if (error.response.status == 400) {
                    this.errors = error.response.data;
                }
            }
        },
        /** Override handleSuccess() to
         *
         * @param {Object} data JSON struct returned by API
         */
        handleSuccess(data) {
            // Add new data to the store if necessary
            // this.$store.dispatch('?', data);

            this.errors = {};  // Success, so clear the errors
            this.$emit('success', data);
            // if (this.isCreate) {
            //     this.flashMessage.success({
            //         title: 'Added', message: ''
            //     });
            // } else {
            //     this.flashMessage.success({
            //         title: 'Updated', message: ''
            //     });
            // }
            // Cleanup actions e.g. wipe cached data
            // this.$store.dispatch('?');

            // Redirect on success?
            // this.$router.push({name: 'account-overview'});
        },
        handleSubmit() {
            console.log("Submitting");
            console.log(this.form);
            if (this.isCreate) {
                // EventService.postMultipartData(this.formUrl, this.$el).then(response => {
                EventService.postMultipartData(this.formUrl, this.form).then(response => {
                    this.handleSuccess(response.data);

                }).catch(error => {
                    this.handleError(error)
                });
            } else {
                EventService.putMultipartData(this.formUrl, this.$el).then(response => {
                    this.handleSuccess(response.data);

                }).catch(error => {
                    this.handleError(error)
                });
            }
        },
    },

};
